import { isEqual } from 'lodash-es';

export const diff = (o1: object | undefined, o2: object | undefined, inverse = false) => {
	o1 = o1 || {};
	o2 = o2 || {};

	const result = {};
	for (const prop in o1) {
		if (!Object.prototype.hasOwnProperty.call(o1, prop)) {
			continue;
		}

		if (typeof o1[prop] === 'object') {
			if (!Object.prototype.hasOwnProperty.call(o2, prop)) {
				result[prop] = {};
			} else {
				if (o1[prop] instanceof Date && o2[prop] instanceof Date) {
					if (o1[prop].getTime() !== o2[prop].getTime()) {
						result[prop] = o1[prop];
					}
				} else {
					if (!o1[prop] && o2[prop]) {
						result[prop] = {};
					} else {
						const childDiff = diff(o1[prop], o2[prop]);
						if (childDiff) {
							result[prop] = childDiff;
						}
					}
				}
			}
		} else if (o2 && o2[prop] !== o1[prop]) {
			result[prop] = o1[prop];
		}
	}

	if (isEqual(result, {})) {
		if (!inverse) {
			// Check the inverse difference - i.e. compare o2's properties to o1's.
			return diff(o2, o1, true);
		}
		return undefined;
	}
	return result;
};
